<ng-container *ngIf="hasFilters() || hasSort()">
  <div [ngClass]="{
    'clearfix': clearfix,
    'd-inline-block': !clearfix
  }">
    <ul class="list-group list-group-horizontal" style="display: inline-flex">
      <!-- Sorting -->
      <ng-container *ngIf="hasSort()">
        <li class='list-group-item border-0 px-0 me-2'>
          <a class="badge badge-breadcrumb-blue border-radius-25 no-text-transform" title="Sorting">
            <i class="{{ getSortIcon() }}"></i>
            <span (click)="clearSorting()" class="badge-circle-close">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
      </ng-container>

      <!-- Filter -->
      <ng-container *ngFor="let item of filter | keyvalue">
        <ng-container *ngIf="displayFilter(item)">
          <li class='list-group-item border-0 px-0 me-2'>
            <a class="badge badge-breadcrumb-blue border-radius-25 no-text-transform" title="{{ keyToLabel(item.key) }}">
              {{ keyToLabel(item.key) }}
              <span (click)="clearFilterKey(item.key)" class="badge-circle-close">
                <i class="fa fa-times"></i>
              </span>
            </a>
          </li>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="hasFilters() || hasSort()">
        <li class='list-group-item border-0 px-0 me-2'>
          <a
            class="badge badge-breadcrumb-red border-radius-25"
            title="Remove all filters"
            (click)="clearAll()">
            <span class="badge-circle-close me-0 ms-0">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-container>
